import Component from '../abstracts/Component';
import { doAjax } from '../utils/ajaxUtil';

export default class NotifyProductUnavailable extends Component {
  get COMPONENTNAME() {
    return 'NotifyProductUnavailable';
  }

  get SELECTORS() {
    return {
      dialogContainer: '.js-product-unavailable',
      buttonBackToShopping: '.js-back-to-shopping',
      buttonShowProductUnavailableForm: '.js-notify-button',
      productUnavailableNotificationForm: '.js-form-container form',
      productUnavailableNotificationFormContainer: '.js-form-container',
      successMessage: '.js-success-message'
    };
  }

  constructor(compEl) {
    super(compEl);
    this.onAfterOpen = this.onAfterOpen.bind(this);
  }

  bindEvents() {
    this.$on(this.$customEvents.MODAL_EVENTS.show, ({ payload }) => {
      if (payload.type === 'product-unavailable') {
        setTimeout(this.onAfterOpen, 1000);
      }
    });
  }

  onAfterOpen() {
    const $dialogBox = $(this.SELECTORS.dialogContainer);
    const $formContainer = $dialogBox.find(this.SELECTORS.productUnavailableNotificationFormContainer);
    $dialogBox.on('click', this.SELECTORS.buttonShowProductUnavailableForm, () => {
      $formContainer.removeClass('hidden');
    });

    $dialogBox.on('click', this.SELECTORS.buttonBackToShopping, () => {
      $('.icon-close').trigger('click');
    });

    $dialogBox.on('submit', this.SELECTORS.productUnavailableNotificationForm, (event) => {
      event.preventDefault();
      const $form = $(event.target);
      const endpoint = $form.attr('action');
      const payload = $form.serialize();

      doAjax({
        url: endpoint,
        data: payload,
        dataType: 'html',
        success: (response) => {
          const $successBox = $dialogBox.find(this.SELECTORS.successMessage);
          $successBox.removeClass('hidden').html(response);
          $formContainer.addClass('hidden');
        }
      });
    });
  }

  render() {
    this.log("Rendering...");
    this.bindEvents();
  }
}
